import { getLocalizedMessage } from './Localization';

export function getBrowserLanguage() {
    const lang = navigator.language;
    if (lang === 'tr-TR' || lang === 'tr')
        return 1;
    if (lang === 'en-US' || lang === 'en')
        return 2;
    if (lang === 'ru-RU' || lang === 'ru')
        return 3;
    if (lang.startsWith('ar'))
        return 4;

    // If the browser does not have any of the languages above, return English
    return 2;
}

export function getLanguage() {
    const lang = getBrowserLanguage();
    console.log(lang);
    const Message = getLocalizedMessage('sharetext', lang);

    if (Message === undefined)
        return 2;

    else
        return lang;
}


